import { linkClick } from '@emico/datalayer-templates'

import dataLayer from './dataLayer'

export function pushLinkClick(
  linkName: string,
  linkCategory: string,
  linkType?: 'internal' | 'external',
) {
  dataLayer.push(...linkClick(linkName, linkCategory, linkType))
}
